import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/userOrganizations",
  name: "userOrganizations",
  redirect: {
    name: "userOrganizations",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/userOrganizations/user",
      name: "user",
      meta: {
        ...meta,
        title: "用户管理",
      },
      component: () => import("@/pages/userOrganizations/user/index.vue"),
    },
    {
      path: '/userOrganizations/role',
      name: 'role',
      meta: {
        title: '角色管理'
      },
      component: () => import('@/pages/userOrganizations/role/index.vue')
    },
    {
      path: '/userOrganizations/channel',
      name: 'channel',
      meta: {
        title: '通道管理'
      },
      component: () => import('@/pages/userOrganizations/channel/index.vue')
    }
  ],
};
